module.exports = __webpack_public_path__ + "static/media/IMG_1533.8e533dcb.JPG";